// Import images for the webpack bundle (copied to theme/static/).
// CHA logos at img root are served via PHP from img/brand/ — skip them here.
const SKIP_IMPORT = /\/logo-cha-(positive|negative)\.svg$/i;

function requireAll(r) {
	r.keys()
		.filter((key) => !SKIP_IMPORT.test(key))
		.forEach(r);
}

requireAll(require.context('./', true, /\.(gif|png|jpe?g|svg|ico)$/i));
